<template functional>
    <div>
        <p>Churn the subscriptions.</p>
    </div>
</template>

<script>
    export default {
        name: 'churn-subscription-summary',
    };
</script>
